import React from "react";
import { generateCoord, getColor } from "../Targets/Generators";
import Target from "../Targets/Target";

/**
 * Generates a duels target
 * @param settingsContext is the settings context
 * @param id is the id of the target
 * @param setScore sets the rounds score
 * @param setMisses sets the rounds misses
 * @param setClicks
 * @param setDistSum
 * @param duration sets the rounds duration
 * @returns a new duels target
 */
const createDuelsTarget = (
  settingsContext: any,
  id: number,
  setScore: React.Dispatch<React.SetStateAction<number>>,
  setMisses: React.Dispatch<React.SetStateAction<number>>,
  setClicks: React.Dispatch<React.SetStateAction<number>>,
  setDistSum: React.Dispatch<React.SetStateAction<number>>,
  duration: number
) => {
  return (
    <Target
      static={true}
      key={id + 1}
      position={generateCoord(-10, 10, -4, 4, -17, -30)}
      size={[1.5, 1.5, 1.5]}
      color={getColor(settingsContext.targetColors)}
      projectileColor={settingsContext.projectileColor}
      scoreUpdater={() => setScore((prev) => prev + 1)}
      missesUpdater={() => setMisses((prev) => prev + 1)}
      clicksUpdater={(clicks: number) => setClicks((prev) => prev + clicks)}
      distancesUpdater={(dist: number) => setDistSum((prev) => prev + dist)}
      duration={duration}
      targetUpwardVel={0}
      targetForwardVel={0}
      targetAcc={0}
      showProjectiles={true}
    />
  );
};

export default createDuelsTarget;
